const privateEventsFilter = () => {
    $('#js__private-hire-filter').selectric();
    $('body').on('change', '#js__private-hire-filter', function() {
        let ID = $(this).find(':selected').val();
        let spaceID = $('.spaces-content').attr('data-space-id');

        privateHireFilter(ID, spaceID, 'select');
    });

    $('.tabs-wrap .col:first-child .js__choose-space').addClass('active');

    $('body').on('click', '.js__choose-space', function(e) {
        e.preventDefault();
        if (!$(this).hasClass('active')) {
            $('.js__choose-space').removeClass('active');
            $(this).addClass('active');
            let ID = $('#js__private-hire-filter').find(':selected').val();
            let spaceID = $(this).attr('data-id');
            privateHireFilter(ID, spaceID, 'click');
        }
    });

    function privateHireFilter(ID, spaceID, type) {
        let loader = '<div class="loader"><div class="ball-clip-rotate"><div></div></div></div>';
        let wrapper = (type === 'select') ? $('#private-hire') : $('#private-hire-content');
        let wrapperHeight = wrapper.innerHeight();
        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: {
                action: 'private_hire_filter',
                ID: ID,
                space_id: spaceID,
                type: type,
            },
            beforeSend: function () {
                $(wrapper).fadeTo(200, 0, function () {
                    $('#loader').html(loader);
                    $('.private-hire-outer-wrap').css('min-height', wrapperHeight + 'px');
                    $(wrapper).empty();
                });
                $(wrapper).fadeTo(400, 1);
            },
            success: function (data) {
                $(wrapper).fadeIn(300, function () {
                    $('#loader .loader').remove();
                    $('.private-hire-outer-wrap').css('min-height', 'auto');
                    $(wrapper).append(data);
                    initScrollingAnimations();
                    allSliders();
                    if (type === 'select') {
                        $('.tabs-wrap .col:first-child .js__choose-space').addClass('active');
                    }
                });
            }
        });
    }
}